<div>
  <mat-card class="example-card">
    <mat-card-header class="titreFrm">
      <mat-card-title>{{titre.toUpperCase()}}</mat-card-title>
    </mat-card-header>
    <mat-card-content class="border">
      <app-show-tree-doc [showAllDocument]=false [File_Groupe]="'3'" [param_code]="param_code" [File_Type]="'collaborateur'" [typeTrs]="typeTrs">
      </app-show-tree-doc>
    </mat-card-content>
  </mat-card>
</div>